// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"25b4bf3c","990":"cf5fe9ca"}[chunkId] + ".chunk.js";
};